<template>
  <header class="app-header">
    <!-- 顶部公告 -->
    <div class="head-top">
      <div class="w-1200 top-inner">
        <div class="notice">
          <marquee scrollamount="5">
            <p>表面增效功能基本上线，多款合并下单价格不完善，请联系客服</p>
          </marquee>
        </div>

        <div class="auth" v-if="user && user.id">
          欢迎您！{{ user.uname }}
          <el-button type="text" @click="logout">退出</el-button>
        </div>

        <div class="auth" v-else>
          <router-link to="/login">登录</router-link>
          <span>|</span>
          <router-link to="/register">注册</router-link>
        </div>
      </div>
    </div>

    <!-- LOGO -->
    <div class="pc-head">
      <div class="w-1200 pc-head-top">
        <router-link to="/" class="logo">
          <img src="@/assets/logo.png" alt="logo" />
        </router-link>

        <div class="contact" @click="openQQ">工厂QQ：78741714</div>

        <!-- 手机菜单按钮 -->
        <div class="mobile-menu-btn" @click="mobileMenu = !mobileMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>

      <!-- 导航 -->
      <div class="header-menu">
        <div class="w-1200">
          <div class="top-menu-main top-menu-wrap">
            <el-menu
              class="top-menu"
              :class="{ mobile: mobileMenu }"
              mode="horizontal"
              background-color="#e5e5e5"
              text-color="#666"
              active-text-color="#409EFF"
              :router="true"
              :default-active="$route.path"
            >
              <!-- 产品分类 -->
              <el-menu-item class="category-trigger" @click="showCategory=!showCategory">
                产品分类
                <i class="el-icon-menu"></i>
              </el-menu-item>

              <el-menu-item index="/">网站首页</el-menu-item>

              <el-menu-item index="/offer">报价下单</el-menu-item>

              <el-menu-item index="/order">订单查询</el-menu-item>

              <el-menu-item index="/matter">注意事项</el-menu-item>

              <el-menu-item index="/guide">操作指引</el-menu-item>

              <el-menu-item index="/contact">联系我们</el-menu-item>
            </el-menu>

            <!-- 产品分类 -->
            <el-menu class="side-menu" :router="true" v-show="showCategory && !mobileMenu" :default-active="$route.path">
              <el-menu-item index="/offer">
                <div class="side-item">
                  <div class="title">卷装标签</div>

                  <div class="desc">合适四色+专色，可变数据，烫金，UV，可平张</div>
                </div>
              </el-menu-item>

              <el-menu-item index="/offer1">
                <div class="side-item">
                  <div class="title">卷装亮银、透明标签</div>

                  <div class="desc">白+四色+专色，可变数据，烫金，UV</div>
                </div>
              </el-menu-item>

              <el-menu-item index="/offer2">
                <div class="side-item">
                  <div class="title">黑白不干胶</div>

                  <div class="desc">黑白印刷，无工艺，可卷可平张</div>
                </div>
              </el-menu-item>

              <el-menu-item index="/ask">
                <div class="side-item">
                  <div class="title">有问有答</div>

                  <div class="desc">费用与工艺说明</div>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'AppHeader',

  data() {
    return {
      // 产品分类
      showCategory: true,

      // 手机菜单
      mobileMenu: false
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },

  methods: {
    logout() {
      this.$confirm('确定退出登录吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('user/logout')
          this.$router.push('/login')
        })
        .catch(() => {})
    },

    openQQ() {
      window.open('https://wpa.qq.com/msgrd?v=3&uin=78741714&site=qq&menu=yes')
    }
  }
}
</script>
<style lang="scss" scoped>
.app-header {
  background: #fff;
  position: relative;
  z-index: 99;
}

.w-1200 {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

/* ===========================
   顶部公告
=========================== */
.head-top {
  background: #232830;
  color: #fecb18;
  padding: 8px 0;

  .top-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .notice {
    flex: 1;
    overflow: hidden;
  }

  i {
    color: red;
    font-style: normal;
    margin: 0 4px;
  }

  .auth {
    display: flex;
    align-items: center;
    white-space: nowrap;

    a {
      color: #fff;
      font-size: 16px;
    }

    span {
      width: 1px;
      height: 16px;
      background: #fff;
      margin: 0 15px;
    }
  }
}

/* ===========================
   Logo
=========================== */

.pc-head {
  background-size: cover;
  background-position: center;

  .pc-head-top {
    height: 99px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo img {
    height: 60px;
    display: block;
  }

  .contact {
    cursor: pointer;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: 16px;

    img {
      margin-right: 8px;
    }
  }
}

/* 手机菜单按钮 */

.mobile-menu-btn {
  display: none;
  width: 42px;
  height: 42px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 30px;
  color: #333;
}

/* ===========================
   导航
=========================== */

/* ===========================
   导航
=========================== */

.header-menu {
  background: #f5f5f5;
}

.top-menu-wrap {
  background: #e5e5e5;
}

.top-menu-main {
  position: relative;
}

.top-menu {
  border-bottom: 1px solid #ddd;
}

.category-trigger {
  width: 240px !important;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}

/* 左侧分类 */

.side-menu {
  position: absolute;
  left: 0;
  top: 61px;

  width: 240px;

  z-index: 999;

  background: #fff;

  border: 1px solid #eee;

  border-top: none;

  .el-menu-item {
    height: auto;
    padding: 12px 16px !important;
    line-height: normal;
    border-bottom: 1px solid #eee;
    background: #fff;
  }

  .side-item {
    text-align: center;

    .title {
      font-size: 17px;
      font-weight: bold;
      color: #333;
    }

    .desc {
      margin-top: 6px;
      color: #409eff;
      line-height: 1.5;
      font-size: 12px;
      white-space: normal;
    }
  }

  .el-menu-item:hover {
    background: #f5faff;
  }

  .el-menu-item.is-active {
    background: #eef7ff;
    border-left: 4px solid #409eff;
  }
}
/* ===========================
   左侧分类
=========================== */

.side-menu {
  width: 240px;
  border-right: 1px solid #e6e6e6;
  position: absolute;
  top: 61px;
  left: 0;
  z-index: 99;

  .el-menu-item {
    height: auto;
    padding: 12px 16px !important;
    line-height: normal;
    background: #f5f5f5;
    border-bottom: 2px solid #005bac85;
  }

  .side-item {
    text-align: center;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      white-space: normal;
      word-break: break-word;
    }

    .desc {
      margin-top: 6px;
      color: #409eff;
      font-size: 12px;
      line-height: 1.5;
      white-space: normal;
      word-break: break-word;
    }
  }

  .el-menu-item.is-active {
    background: #f0f7ff;
    border-left: 4px solid #409eff;
  }
}

/* ===========================
   内容
=========================== */

.main-wrap {
  background: #fff;
}

.main-1200 {
  max-width: 1200px;
  margin: auto;
  display: flex;
}

.content {
  flex: 1;
  padding: 20px;
  min-height: 500px;
}

/* ==========================================================
   手机
========================================================== */

@media screen and (max-width: 768px) {
  .w-1200 {
    padding: 0 15px;
  }

  /* 顶部公告 */

  .head-top {
    padding: 6px 0;

    .top-inner {
      flex-direction: column;

      align-items: flex-start;
    }

    .notice {
      width: 100%;

      font-size: 12px;
    }

    .auth {
      margin-top: 5px;

      font-size: 13px;
    }
  }

  /* Logo */

  .pc-head {
    .pc-head-top {
      height: 60px;
    }

    .logo img {
      height: 40px;
    }

    .contact {
      display: none;
    }
  }

  /* 汉堡按钮 */

  .mobile-menu-btn {
    display: flex;
  }

  /* 顶部菜单 */

  .top-menu {
    display: none;
  }

  .top-menu.mobile {
    display: block;

    width: 100%;

    position: absolute;

    left: 0;

    top: 0;

    z-index: 999;

    background: #fff;

    border: none;
  }

  .top-menu.mobile.el-menu--horizontal {
    height: auto;
  }

  .top-menu.mobile.el-menu--horizontal > .el-menu-item {
    float: none;

    width: 100%;

    height: 50px;

    line-height: 50px;

    border-bottom: 1px solid #eee;
  }

  .category-trigger {
    width: 100%;
  }

  /* 分类 */

  .side-menu {
    position: relative;

    width: 100%;

    top: 0;

    left: 0;

    border-right: none;

    border-top: 1px solid #eee;
  }

  .side-menu .el-menu-item {
    padding: 14px !important;
  }

  .side-item {
    text-align: left;
  }

  .side-item .title {
    font-size: 16px;
  }

  .side-item .desc {
    font-size: 12px;
  }

  /* 内容 */

  .main-1200 {
    flex-direction: column;
  }

  .content {
    width: 100%;

    padding: 15px;

    min-height: auto;

    box-sizing: border-box;
  }
}

/* 超小屏 */

@media screen and (max-width: 480px) {
  .pc-head .logo img {
    height: 34px;
  }

  .head-top {
    display: none;
  }
}
</style>